jQuery.event.special.touchstart = {
    setup: function( _, ns, handle ){
        this.addEventListener("touchstart", handle, { passive: true });
    }
};

$(".openKlaviyoNewsletter").click(function(e){
    e.preventDefault();
    modal1.style.display = "block";
}); 

// // Get the modal
// var modal1 = document.getElementById("myModal1");

// // Get the <span> element that closes the modal
// var span1 = document.getElementsByClassName("close1")[0];

// // When the user clicks on <span> (x), close the modal
// span1.onclick = function() {
//   modal1.style.display = "none";
// }

// // When the user clicks anywhere outside of the modal, close it
// window.onclick = function(event) {
//   if (event.target == modal1) {
//     modal1.style.display = "none";
//   }
// }

// DROPDOWN See the format in cart page LSF
$('.dropdown-menu label').on('click', function(){
    $(this).parents('.dropdown').removeClass('open');
    var value = $(this).find('input').val();
    $('.dropdown-menu label').not(this).parents('li').removeClass('active');
    $('.dropdown-toggle .plc').text(value).addClass('bld');
});

// HOMEPAGE video
$('.html5-video-trigger').click(function(){
    var video = $("#"+$(this).attr('data-video'));
    video = video.get(0);
    if ($(this).hasClass('pause-btn')) {
        video.play();
        $(this).hide();
        $(this).siblings().show();
    } else {
        video.pause();
        $(this).hide();
        $(this).siblings().show();
    }
});

// Youtube pdp if background is not present
$(document).ready(function() {
    $(".content-or-pro.yt").each(function(){
        var hasBGImage = $(this).css('background-image') !== 'none';
        if (hasBGImage == false) {
            var ytbId = $('#myModal-video iframe').attr('src');
            ytbId = ytbId.split('/');
            var bgImage = 'https://img.youtube.com/vi/'+ytbId[ytbId.length - 1]+'/maxresdefault.jpg';
            $(this).css({
               'background-image' : 'url('+bgImage+')',
               'background-repeat' : 'no-repeat',
               'background-size' : 'cover',
               'background-position' : 'center bottom'
            });
        }
    });

    // GENERAL COLLAPSE [parent, trigger, container-target]
    $('.collapse-trigger').click(function(){
        var target = $(this).attr('data-target');
        var parent = $(this).parent();
        parent.toggleClass('collapse-active');
        $(target).slideToggle();
    })
    // PRODUCTS
    $('.trigger-delivery-info').click(function(){
        $(this).toggleClass('active');
        $(this).parents('p').toggleClass('open');
        var target = $(this).attr('data-target');

        $('.delivery-info.'+target).toggleClass('hide');
        $('.delivery-info:not(.'+target+')').addClass('hide');
        $('.trigger-delivery-info').not(this).removeClass('active');
        $('.trigger-delivery-info').not(this).parents('p').removeClass('open');

        //Adjusting with other element
        $('.product-summary').addClass('z-index-1');
    });
    $('.delivery-info .close').click(function(){
        var parent = $(this).parent();
        var iconSource = $(this).attr('data-icon');
        parent.addClass('hide');
        $('.delivery-check-result p').removeClass('open');
        $('.trigger-delivery-info[data-target='+iconSource+']').removeClass('active');
    })

});

// SMOOTH SCROLL ALL URL WITH HASH #
if(window.location.hash) {
    var hash = window.location.hash;
    $('html, body').animate({
        scrollTop: $(hash).offset().top - 90
    }, 3000, 'swing');
}

//ACTIVE COLLECTION ON PAGE MENU when scroll
// $(function() {
//     var sections = $('section');
//     var navigation_links = $('nav a');
//     sections.waypoint({
//     handler: function(direction) {
//         var active_section;
//         active_section = $(this);
//         if (direction === "up") active_section = active_section.prev();
//         var active_link = $('nav a[data-target="#' + active_section.attr("id") + '"]');
//         navigation_links.parent().removeClass("active");
//         active_link.parent().addClass("active");
//     //active_section.addClass("active-section");
//     }, offset: '35%'});
// });

// Postage calculator #01 (typing...)
$(document).ready(function() {
    $('input#postcode1').val('');
  $('input#postcode1').keyup(function(e){  
    var txtInput = $(this).val();
    if (txtInput.length > 2){
      $('#suburb').css('height', 'auto');
      $('#suburb').slideDown();
      $('#suburb').addClass('active');
      $('#suburb ul').html('');
      $('#suburb  .spinner').show();
      e.preventDefault();
      $.ajax({
        url: "https://1117015.extforms.netsuite.com/app/site/hosting/scriptlet.nl?script=713&deploy=1&compid=1117015&ns-at=AAEJ7tMQEHiNlvu41bPcPH-Klcl0BC-WPko6HsiOAER-WqJ5IqE&q="+txtInput,
        type: "get",
        crosscallDomain: true,
        dataType: "jsonp"
      })
      .done(function (data) {
        $('#suburb ul').html('');
        if (data.localities == "") {
          $('#suburb .spinner').hide();
          $('#suburb ul').append('<li><strong>Not Found</strong></li>')
        } else {
          displaySuburb(data.localities.locality);
        }
      })
      .fail(function(jqXHR, textStatus, errorThrown) {
        console.log(textStatus + '; ' + errorThrown);
      })
    } else {
      $('#suburb').removeClass('active');
    }
  });
});

function isObject (value) {
  return value && typeof value === 'object' && value.constructor === Object;
}

// Postage calculator #02 (display suburb)
function displaySuburb(data) {
  $('#suburb .spinner').show();
  if (isObject(data)) {
    $('#suburb ul').html('');
    $('#suburb .spinner').hide();
    $('#suburb ul').append('<li><strong>'+data.location+'</strong>, '+data.state+', '+data.postcode+'</li>')
  } else {
    $('#suburb ul').html('');
    $('#suburb .spinner').hide();
    for (var i = 0; i < data.length; i++) {
      $('#suburb ul').append('<li><strong>'+data[i].location+'</strong>, '+data[i].state+', '+data[i].postcode+'</li>')
    }
  }
}

// Postage calculator #03 (get suburb)
$("#suburb ul").on('click','li', function(ev) {
  $('#suburb').slideUp();
  var selectedLoc = $(this).text().split(',');
  $('#postcode1').val($(this).text());
  var selectedSuburb = selectedLoc[0].replace(/ /gi, "+");
  var selectedPostcode = selectedLoc[2];

  $('#productId').attr('data-postcode', selectedPostcode);
  $('#productId').attr('data-suburb', selectedSuburb);
}); 

// Postage calculator #04 (click go)
$('#deliverytrigger1').click(function(e){
    e.preventDefault();
  if ($('#postcode1').val() != "") {
    $('.check-result-container').slideUp('fast');
    var postcode = $('#productId').attr('data-postcode').replace(' ', '');
    var suburb = $('#productId').attr('data-suburb');
    if ($('.this-is-cart-page').length != 0 ) {
        var sku = $('#allsku').attr('data-sku');
    } else {
        var sku = $('.sku').text();
    }
    if ($('#postcode1').val().split(',')[0].replace(/ /gi, "+") == suburb) {
      postageCalc(postcode, suburb, sku);
    }
  }
});

// Postage calculator #05 (ajax call...)
function postageCalc(postcode, suburb, sku){
  var url = 'https://1117015.extforms.netsuite.com/app/site/hosting/scriptlet.nl?script=712&deploy=1&compid=1117015&ns-at=AAEJ7tMQmWDVLsk37sTXyeC7k2gKi91BwzdlLcYf8Y9arlMnQew&postcode='+postcode+'&suburb='+suburb+'&item_sku='+sku+'&source=walkingpad-australia';
  $.ajax(
    {
      url: url,
      type: "get",
      crosscallDomain: true,
      dataType: "jsonp",
      beforeSend: function(xhr) {
        $('.spinner-1').show();
      }
    }
  ).done(function(data) {
    updatePrice(data.uniq_rates);
  }).fail(function() {
      $('#postage-results').html('Unkown errors, please try again later!');
  })
}
// Postage calculator #06 (display price) 
function updatePrice(all_rates){
    if (all_rates === undefined == false ) {
        jQuery(window).trigger('resize').trigger('scroll');
        $('.delivery-pickup .spinner-1').show();
        // Default hidden carrier
        $('.premium_diverse-container').hide();
        // Prices
        $('.delivery-check-result').show();
        $('.delivery-check-result .rate').html("Not Available");
        $('.delivery-check-result #regular').html("Please contact us for a quote");
        // Update cart page
        $('.default-hide.cart-page').hide();

        $('#noprice').hide();
        // Jason files sourced from LSF, don't forget to update the version
        $.getJSON("https://lifespanonline.com.au/postage-query/info/delivery-information.json?123", function (result){
            $( ".delivery-info" ).each(function( index ) {
               var classData = $(this).attr('data-deliveryinfo');
                if (result[classData]) {
                   $( ".delivery-info."+classData + ' ul').html(result[classData].includes.join(""));
                   result[classData].additional_info != "" && $( ".delivery-info."+classData + ' ul').append(result[classData].additional_info);
                }
            });

            // Display prices
            for (var i = 0; i < all_rates.length; i++) {
                var idPrices = all_rates[i].type.replace(/\|/g, '_');

                //re-display cart delivery option in cart page [should add .default-hide]
                $('.cart-page.'+idPrices).show();
                if (all_rates[i].total_price == 0) {
                    $('.delivery-check-result #'+idPrices).html(result[idPrices].if_zero);
                } else {
                    var ratedelivery = all_rates[i].total_price.toFixed(2);
                    $('.delivery-check-result #'+idPrices).html("$" + ratedelivery);
                }
                // Display carrier which is hidden by default
                if (all_rates[i].type == 'premium|diverse') {
                    $('.premium_diverse-container').show();
                }
                if (all_rates[i].type == 'pickup') {
                    // Get exact location NSW or VIC for pikcup
                    var pickupLoc = all_rates[i].display_code.split('@');
                    if (pickupLoc.length == 2) {
                        $('.pickup-container').show();
                        $("#pickupLoc").html(pickupLoc[1]);
                    } else {
                        $('.pickup-container').hide();
                    }
                }
            }
        });
    } else {
        $('.delivery-check-result').hide();
        $('.check-result-container').append('<p id="noprice" style="font-size:13px;">Please contact us via online chat or phone for a tailored shipping quote. </p>');
    }
    $('.delivery-pickup .spinner-1').hide();
    $('.check-result-container').slideDown('slow');
}


// WHEN POSTCODE OR SKU is incorrect
function showError(data){
  jQuery(window).trigger('resize').trigger('scroll');
  $('.delivery-pickup .spinner-1').hide();
  $('.check-result-container').slideDown('slow');
  var i;
  for (i = data.length - 1; i >= 0; i--) {
    $('.delivery-check-result').html("<p style='color: #F8ACAC'>"+data[i]+"</p>");
  }
}

// Assembly services on every pdp
$(document).on("click", "#productAddAssembly", function() {
    var y = $('.productaddassembly-text'),
        S = $('#form-productAddAssembly'),
        U = $('#cart-product-assembly'),
        id = U.attr('data-key');
    if (U.hasClass('in-cart')) {
        return $.ajax({
            type: "POST",
            url: "/cart/change.js",
            data: "quantity="+0+"&id="+id,
            dataType: "json",
            beforeSend: function() {
                $(".product-assembly-msg").show();
                $(".product-assembly-msg").text("Removing...");
            },
            success: function(E) {
                $(".product-assembly-msg").text("Removed");
                setTimeout(function(){ $(".product-assembly-msg").hide() }, 1000);
                U.removeClass('in-cart');
            },
            error: function(E) {
                console.log(E);
            }
        })
    } else {
        return $.ajax({
            type: "POST",
            url: "/cart/add.js",
            async: !0,
            cache: !1,
            data: S.serialize(),
            dataType: "json",
            beforeSend: function() {
                $(".product-assembly-msg").show();
                $(".product-assembly-msg").text("Adding...");
            },
            complete: function() {
                $(".product-assembly-msg").text("Added");
                setTimeout(function(){ $(".product-assembly-msg").hide() }, 1000);
                U.prop('checked', true);
                U.addClass('in-cart');
            },
            error: function(T) {
                console.log(T)
            },
            success: function(T) {
                U.attr('data-key', T.key)
            }
        }).done(function() {}), !1
    }
})

$("#availability-trigger").on('click', function(ev) {
    pickUpLocation();
}); 

// Stock Availability in each store #02 (Quantity)
function getQuantityData(logResults){
  var isMulti = $('.sku').attr('data-multisku');
  var url;
  if (isMulti == 'false') {
    var sku = $('.sku').text();
  } else {
    var sku = $('.sku').attr('data-skus');
  }
  var data;
  $.ajax({
    url: "https://1117015.extforms.netsuite.com/app/site/hosting/scriptlet.nl?script=623&deploy=1&compid=1117015&ns-at=AAEJ7tMQkyX-9quosAYuoRdLWndgI5fkODhy5BL-FR50CUontp0&item_key_type=sku&item_keys="+sku+"&location=15,10,9&jsonp=y",
    type: "get",
    crosscallDomain: true,
    dataType: "jsonp",
    jsonpCallback: "logResults",
    success: function (resp) {
      data = resp;
      logResults(data.inventory);
    },
    error: function () {}
  });
}
// Stock Availability in each store #03 (Display)
function pickUpLocation(){
  getQuantityData(function(dataQuantity) {
    var d = dataQuantity[0].inventory;
    if (dataQuantity.length == 1) {
      for (var l = 0; l < d.length; l++) {
        if (d[l].location_quantity_available < 10 ) {
          if (d[l].location_quantity_available < 1 ) {
            $("#dynamicPickUpResult #location-"+d[l].inventory_location_id).addClass('notavailable');
            $("#dynamicPickUpResult #location-"+d[l].inventory_location_id).text('Out of Stock');
           } else {
            $("#dynamicPickUpResult #location-"+d[l].inventory_location_id).addClass('limited-stock');
            $("#dynamicPickUpResult #location-"+d[l].inventory_location_id).text('Limited Stock');
          }
        }else{
          $("#dynamicPickUpResult #location-"+d[l].inventory_location_id).addClass('available');
          $("#dynamicPickUpResult #location-"+d[l].inventory_location_id).text('In Stock');
        }
      }
    }
    if (dataQuantity.length > 1) {
        $("#dynamicPickUpResult .result .t").text('');
      for (var k = 0; k < dataQuantity.length; k++) {
        var sku = dataQuantity[k].sku.replace('.', '-');
        for (var m =  0; m < dataQuantity[k].inventory.length; m++) {
          // Minimise loading time we only process the exact location id
          var locId = dataQuantity[k].inventory[m].inventory_location_id;
          if (locId == '15') {
            var invQuant = dataQuantity[k].inventory[m].location_quantity_available;
            var locationId = '.location-'+locId+'.'+sku;
            if (invQuant < 10 ) {
              if (invQuant < 1 ) {
                $("#dynamicPickUpResult "+locationId).addClass('notavailable');
                $("#dynamicPickUpResult "+locationId+" .t").append('Out of Stock');
              } else {
                $("#dynamicPickUpResult "+locationId).addClass('limited-stock');
                $("#dynamicPickUpResult "+locationId+" .t").append('Limited Stock');
              }
            }else{
              $("#dynamicPickUpResult "+locationId).addClass('available');
              $("#dynamicPickUpResult "+locationId+" .t").append('In Stock');
            }
          }
        }
      }
    }
  });
}

// CART WIDGET IN HEADER
$("#cart_content").on('click','a', function(ev) {
    window.location = $(this).attr("href");
}); 

// PSP FILTER
$('.sidebar-product-type-filter').on('change', 'input', function() {    
    var all = $('li.filter-all');
    var allInput = all.find('input');
    $('body').prepend('<div class="spinner-collection hide"><div class="spinner"><img src="https://cdn.shopify.com/s/files/1/0268/0818/9012/t/6/assets/ajax-loader.gif" alt="Spinner" /></div></div>');
    if ($(this).val() != 'all') {
        $('.spinner-collection').removeClass('hide');
        var N = $('.'+$(this).val());
        if(this.checked) {
            var count = 0;
            for (var i = 1; i < $('.filter-sidebar input').length; i++) {
                if ($('.filter-sidebar input')[i].checked == true){count++;}
            }
            if (count == $('.filter-sidebar input').length - 1) {
                all.addClass('active disabled');
                allInput.attr('disabled', 'disabled');
                allInput.prop("checked", true);
            }
            setTimeout(function() {
                N.show();
                $('.spinner-collection').remove();
            }, 1000);
        } else {
            all.removeClass('active disabled');
            allInput.removeAttr('disabled');
            allInput.removeAttr('checked');
            setTimeout(function() {
                N.hide();
                $('.spinner-collection').remove();
            }, 1000);
        }
    }else{
        $('.spinner-collection').removeClass('hide');
        setTimeout(function(){
            $('.spinner-collection').remove();
            $(".filter-sidebar input").each(function(){
                if (this.disabled == false){
                    $('.type-container.'+this.value).show();
                }
            });
        }, 1000);
        all.addClass('active');
        $(this).attr('disabled', 'disabled')
        $('.filter-sidebar input').prop("checked", true);
        var N = $('.'+$(this).val());
    }
});
$('.sidebar-product-price-filter').on('change', 'input', function() {
    var n = $(this);   
    var all = $('li.filter-all-price');
    var allInput = all.find('input');
    var url = n.attr('data-href');
    $('body').prepend('<div class="spinner-collection hide"><div class="spinner"><img src="https://cdn.shopify.com/s/files/1/0268/0818/9012/t/6/assets/ajax-loader.gif" alt="Spinner" /></div></div>');
    if(this.checked){
        $('.sidebar-product-price-filter input').not(this).prop("checked", false);
        $('.sidebar-product-price-filter input').not(this).removeAttr('disabled');
        $('.sidebar-product-price-filter li').removeClass('active disabled');
        n.parents('li').addClass('active disabled');
        n.attr('disabled', 'disabled');
        $.ajax({
            url: url+'?view=filter',
            beforeSend: function(){
                $('.spinner-collection').removeClass('hide');
            }
        }).done(function(data) {
            var priceMax;
            var priceMin;
            var price = n.val();
            if (price.indexOf('-') !== -1){
                priceMin = parseInt(price.split('-')[0]);
                priceMax = parseInt(price.split('-')[1]);
            } else {
                priceMin = parseInt(price);
                priceMax = false;
            };
            $(data).find('.type-container').each(function(){
                var parentClass = '.'+$(this).attr('data-type');
                var count = 0;
                if (n.val() != 'all') {
                    $(parentClass).find('.product-item').remove();
                    $(this).find('.product-item').each(function(){
                        var priceReal = parseInt($(this).find('.price-real').text().replace('$', ''));
                        if (priceMax == false) {
                            if (priceReal > priceMin) { 
                                $(parentClass).append($(this));
                                count++;
                            }
                        } else {
                            if (priceReal > priceMin && priceReal < priceMax) {
                                $(parentClass).append($(this));
                                count++;
                            }
                        }
                    })
                } else {
                    $(parentClass).find('.product-item').remove();
                    $(this).find('.product-item').each(function(){
                        $(parentClass).append($(this));
                        count++;
                    })
                }
                var navFilter = 'li'+parentClass.replace('type', 'filter');
                $(navFilter+' label .count').html(count);
                $(navFilter+' input').prop('checked', true);
                if (parseInt(count) < 1) {
                    $(parentClass).hide();
                    $('.sidebar-product-type-filter '+navFilter+' input').attr('disabled', 'disabled');
                    $(navFilter).addClass('disabled');
                } else {
                    $(parentClass).show();
                    $('.sidebar-product-type-filter '+navFilter+' input').removeAttr('disabled');
                    $('.sidebar-product-type-filter '+navFilter).removeClass('disabled');
                }
            })
            $('.spinner-collection').remove();
        }).fail(function(jqXHR, textStatus, errorThrown) {
            console.log(textStatus + '; ' + errorThrown);
            //$('body .loader-container').remove();
        })
    }
});
$('.sidebar-nav-trigger').on('click', function(){
    $(this).toggleClass('target-open')
    var openTarget = $(this).attr('data-target');
    $('.'+openTarget).slideToggle();
});